import {NewsItemId} from "../types/NewsItemId";
import {OffsetDateTime} from "../../pseudo-types/DateTypes";
import {NewsItemType} from "../types/NewsItemType";
import {CodeAndExchange, Securities} from "../../instruments/types/CodeAndExchange";
import {NewsVendor} from "../types/NewsVendors";

export type NewsHeadlineRecords = ReadonlyArray<NewsHeadlineRecord>;

export interface NewsHeadlineRecord extends CodeAndExchange {
    readonly id: NewsItemId;
    readonly at: OffsetDateTime;
    readonly type: NewsItemType;
    readonly marketSensitive: boolean;
    readonly securities: Securities;
    readonly vendor: NewsVendor;
    readonly title: string;
    readonly summary?: string;
    readonly hasContent: boolean;
}

export interface TextNewsHeadlineRecord extends NewsHeadlineRecord {
    readonly type: NewsItemType.TEXT;
}

export function isTextHeadline(headline: NewsHeadlineRecord): headline is TextNewsHeadlineRecord {
    return headline.type === NewsItemType.TEXT;
}

export interface HtmlNewsHeadlineRecord extends NewsHeadlineRecord {
    readonly type: NewsItemType.HTML;
    readonly hasContent: true;
}

export function isHtmlHeadline(headline: NewsHeadlineRecord): headline is HtmlNewsHeadlineRecord {
    return headline.type === NewsItemType.HTML;
}

export interface PdfNewsHeadlineRecord extends NewsHeadlineRecord {
    readonly type: NewsItemType.DOCUMENT;
    readonly url: string;
    readonly hasContent: false;
}

export function isPdfHeadline(headline: NewsHeadlineRecord): headline is PdfNewsHeadlineRecord {
    return headline.type === NewsItemType.DOCUMENT;
}
